module.exports = __webpack_public_path__ + "fa-brands-400.30cc681d4487d2f56103.eot";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/webfonts/fa-brands-400.eot
// module id = ../../../../../src/assets/fonts/webfonts/fa-brands-400.eot
// module chunks = styles